<mat-card appearance="outlined" telemetry="Card-SmartMeterPortalUsageChart-UtilityBilling">
    <mat-card-header>
        <mat-card-title>
            Smart Meter Portal Usage
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </mat-card-content>
</mat-card>
